import { render, staticRenderFns } from "./list.vue?vue&type=template&id=4c096205&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=4c096205&lang=less&scoped=true&"
import style1 from "./list.vue?vue&type=style&index=1&id=4c096205&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c096205",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c096205')) {
      api.createRecord('4c096205', component.options)
    } else {
      api.reload('4c096205', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=4c096205&scoped=true&", function () {
      api.rerender('4c096205', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/deceased/list.vue"
export default component.exports